export default __webpack_public_path__ + "static/media/dianoiva_1.1f7bc662.jpg";